module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('companyName')
    }
  }, [_c('label', {
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v("Nom de l'entreprise *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.companyName),
      expression: "companyData.companyName"
    }],
    attrs: {
      "type": "text",
      "name": "companyName"
    },
    domProps: {
      "value": (_vm.companyData.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "companyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('companyName')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('registrationNumber')
    }
  }, [_c('label', {
    attrs: {
      "for": "registrationNumber"
    }
  }, [_vm._v("Numéro d'immatriculation (SIREN/SIRET) *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.registrationNumber),
      expression: "companyData.registrationNumber"
    }],
    attrs: {
      "type": "text",
      "name": "registrationNumber"
    },
    domProps: {
      "value": (_vm.companyData.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "registrationNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('registrationNumber')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('registrationNumber')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('headquartersAddress')
    }
  }, [_c('label', {
    attrs: {
      "for": "headquartersAddress"
    }
  }, [_vm._v("Adresse du siège social *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.headquartersAddress),
      expression: "companyData.headquartersAddress"
    }],
    attrs: {
      "name": "headquartersAddress",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.companyData.headquartersAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "headquartersAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('headquartersAddress')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('headquartersAddress')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "taxRegime"
    }
  }, [_vm._v("Régime Fiscal *")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.taxRegimes,
      "selected": _vm.companyData.taxRegime,
      "solo": true
    },
    on: {
      "change": function($event) {
        _vm.companyData.taxRegime = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('activities')
    }
  }, [_c('label', {
    attrs: {
      "for": "activities"
    }
  }, [_vm._v("Activités *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.companyData.activities),
      expression: "companyData.activities"
    }],
    attrs: {
      "name": "activities",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.companyData.activities)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyData, "activities", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('activities')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('activities')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dirigeant(s) *")]), _vm._v(" "), _vm._l((_vm.companyData.managers), function(manager, index) {
    return _c('div', {
      key: 'manager-' + index,
      staticClass: "dynamic-field-row"
    }, [_c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.companyData.managers[index]),
        expression: "companyData.managers[index]"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Nom et prénom du dirigeant"
      },
      domProps: {
        "value": (_vm.companyData.managers[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.companyData.managers, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.companyData.managers.length > 1) ? _c('button', {
      staticClass: "btn-icon btn-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeManager(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-trash"
    }, [_vm._v("x")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-gold btn-add-field",
    on: {
      "click": _vm.addManager
    }
  }, [_c('span', {
    staticClass: "icon-plus"
  }, [_vm._v("+")]), _vm._v(" Ajouter un dirigeant\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Bénéficiaires effectifs *")]), _vm._v(" "), _vm._l((_vm.companyData.beneficiaries), function(beneficiary, index) {
    return _c('div', {
      key: 'beneficiary-' + index,
      staticClass: "dynamic-field-row"
    }, [_c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.companyData.beneficiaries[index]),
        expression: "companyData.beneficiaries[index]"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Nom du bénéficiaire effectif"
      },
      domProps: {
        "value": (_vm.companyData.beneficiaries[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.companyData.beneficiaries, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.companyData.beneficiaries.length > 1) ? _c('button', {
      staticClass: "btn-icon btn-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeBeneficiary(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-trash"
    }, [_vm._v("x")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-gold btn-add-field",
    on: {
      "click": _vm.addBeneficiary
    }
  }, [_c('span', {
    staticClass: "icon-plus"
  }), _vm._v(" Ajouter un bénéficiaire effectif\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container documents-confirmation"
  }, [_c('p', {
    staticClass: "document-text"
  }, [_vm._v("\n          En tant que représentant légal je confirme avoir transmis les documents suivants :\n          une copie du K-bis de moins de 3 mois ou équivalent, Copie des statuts,\n          Dernier bilan/compte de résultat ou tout au moins un état financier.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-row row"
  }, [_c('custom-toggle', {
    attrs: {
      "value": _vm.companyData.documentsConfirmed
    },
    on: {
      "change": function($event) {
        _vm.companyData.documentsConfirmed = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-label"
  }, [_vm._v("Je confirme avoir transmis les documents")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container signature-confirmation"
  }, [_c('div', {
    staticClass: "label solo bold"
  }, [_vm._v("\n          Je confirme que les informations renseignées sont exactes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-row row"
  }, [_c('custom-toggle', {
    attrs: {
      "value": _vm.companyData.signatureConfirmed
    },
    on: {
      "change": function($event) {
        _vm.companyData.signatureConfirmed = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-label"
  }, [_vm._v("Je confirme l'exactitude des informations")])], 1), _vm._v(" "), (_vm.isAdvisor) ? _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n          En cliquant sur \"Demande de signature électronique\" un e-mail sera envoyé au client lui permettant de signer électroniquement les informations de la société que vous avez complété.\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAdvisor) ? _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n          En cliquant sur \"Signer\" vous allez être redirigé vers notre module de signature électronique afin de valider la saisie des informations de votre société.\n        ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.signaturePopupBlocked) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "alert-wrapper row"
  }, [_c('span', {
    staticClass: "icon icon-alert"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('div', {
    staticClass: "alert-content column"
  }, [_c('p', [_vm._v("\n                Votre navigateur a pu bloquer la fenêtre d'accès à la signature.\n                "), _c('br'), _vm._v("\n                C'est courant, cliquez sur le bouton à droite pour accéder au service de signature.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showUnlockPopupTuto = true
      }
    }
  }, [_vm._v("\n              Voir les instructions\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), (!_vm.companyData.documentsConfirmed || !_vm.companyData.signatureConfirmed) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Sauvegarder")]) : _c('div', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.companyData.signatureConfirmed
    },
    on: {
      "click": _vm.signDocument
    }
  }, [(_vm.isAdvisor) ? [_vm._v("Demande de signature électronique")] : [_vm._v("Signer")]], 2)])], 1)]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showRgpdModal,
      "content": _vm.modalRgpd
    },
    on: {
      "close": function($event) {
        _vm.showRgpdModal = false
      }
    }
  }), _vm._v(" "), (_vm.showUnlockPopupTuto) ? _c('unlock-signature-popup-tutorial', {
    on: {
      "close": function($event) {
        _vm.showUnlockPopupTuto = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n        Informations Société\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n        Complétez les informations de la société (personne morale)\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1888767d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/CompanyInformation.vue
// module id = 1076
// module chunks = 0